module.exports = __webpack_public_path__ + "static/media/settings.c47730b3.svg";